import { Col, Row, Skeleton } from "antd";
import { Utils } from "../../../../Utilities/Utils";
import { dayjs } from "../../../../Utilities/dayjs";
import { PriceHistoryByItemIdResponse } from "../../../Services/VoucherServices";
interface PriceHistoryProps {
  data: PriceHistoryByItemIdResponse[];
  themeColor: string;
  loading: boolean;
}

export const ShowPriceHistoryDataView = ({
  data,
  themeColor,
  loading,
}: PriceHistoryProps) => {
  return (
    <div
      style={{
        position: "absolute",
        zIndex: 999,
        width: "500px",
        marginTop: "5px",
        background: "white",
        padding: "6px",
        border: `solid ${themeColor} 2px`,
      }}
    >
      <Row>
        <Col>
          <h4>Price history:</h4>
        </Col>
      </Row>
      <Skeleton
        loading={loading}
        paragraph={{ rows: 2, width: "100%" }}
        title={false}
      >
        <Row>
          {data.length > 0 ? (
            <Col span={24}>
              <table
                className="ca-viewmodel-table"
                style={{
                  marginTop: "2px",
                }}
              >
                <thead>
                  <th
                    style={{
                      width: "30%",
                      textAlign: "left",
                    }}
                  >
                    Party Name
                  </th>
                  <th
                    style={{
                      width: "20%",
                    }}
                  >
                    Date
                  </th>
                  <th
                    style={{
                      width: "20%",
                    }}
                  >
                    Voucher No.
                  </th>
                  <th
                    style={{
                      width: "10%",
                    }}
                  >
                    Qty
                  </th>
                  <th
                    style={{
                      width: "20%",
                      textAlign: "right",
                    }}
                  >
                    Rate
                  </th>
                </thead>
                <tbody>
                  {data?.map((row: PriceHistoryByItemIdResponse) => (
                    <tr
                      style={{
                        verticalAlign: "top",
                      }}
                    >
                      <td
                        style={{
                          textAlign: "left",
                        }}
                      >
                        {row.partyName}
                      </td>
                      <td
                        style={{
                          textAlign: "center",
                        }}
                      >
                        {dayjs(row.voucherDate).format("DD/MM/YYYY")}
                      </td>
                      <td
                        style={{
                          textAlign: "center",
                        }}
                      >
                        {row.voucherNumber}
                      </td>
                      <td
                        style={{
                          textAlign: "center",
                        }}
                      >
                        {row.items?.map((itm: any, itmIndex: number) =>
                          itmIndex === row.items?.length ? (
                            itm.itemQty
                          ) : (
                            <>
                              {itm.itemQty}
                              <br />
                            </>
                          )
                        )}
                      </td>
                      <td
                        style={{
                          textAlign: "right",
                        }}
                      >
                        {row.items?.map((itm: any, itmIndex: number) =>
                          itmIndex === row.items?.length ? (
                            Utils.getFormattedNumber(itm.itemPrice)
                          ) : (
                            <>
                              {Utils.getFormattedNumber(itm.itemPrice)}
                              <br />
                            </>
                          )
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </Col>
          ) : (
            <Col span={24}>
              <p>No price history data</p>
            </Col>
          )}
        </Row>
      </Skeleton>
    </div>
  );
};
